import React, { FC, ReactElement } from 'react'
import { PasswordPopover } from '../password-popover/password-popover'
import { PasswordValidators } from '../../_utils/password-validations'
import { UserDto } from '../../dtos/user'
import { Form, Input } from 'antd'
import { Rule } from 'antd/lib/form'

type IPasswordFormProps = {
    user: UserDto
}

const PasswordForm: FC<React.PropsWithChildren<IPasswordFormProps>> = ({ user }): ReactElement => {
    const passwordRules: Rule[] = user
        ? []
        : [
              {
                  required: true,
                  message: 'Password is required',
              },
          ]

    const passwordVerifyRules: Rule[] = user
        ? []
        : [
              {
                  required: true,
                  message: 'Password verification is required',
              },
          ]

    const matchesFirstPassword: Rule = ({ getFieldValue }) => ({
        validator: (_rule, value) =>
            !value || value === getFieldValue('password')
                ? Promise.resolve()
                : Promise.reject(new Error('Passwords do not match')),
    })

    return (
        <>
            <Form.Item
                name="password"
                label="Password"
                rules={passwordRules.concat([
                    {
                        validator: new PasswordValidators(user).validate,
                    },
                ])}
            >
                <PasswordPopover>
                    <Input.Password autoComplete="new-password" />
                </PasswordPopover>
            </Form.Item>
            <Form.Item
                name="passwordVerify"
                label="Verify Password"
                // Re-runs the match check when the password above is edited, so a
                // stale "do not match" error clears itself instead of blocking submit.
                dependencies={['password']}
                rules={passwordVerifyRules.concat([matchesFirstPassword])}
            >
                <Input.Password placeholder="Verify password" autoComplete="new-password" />
            </Form.Item>
        </>
    )
}

export { PasswordForm }
